import { render } from "./AppTableHead.vue?vue&type=template&id=6b9df7aa&ts=true"
import script from "./AppTableHead.vue?vue&type=script&lang=ts"
export * from "./AppTableHead.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/wVusKqw4/0/kenniss/platform/educator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__